import {
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import React from "react";
import { useRootStore } from "store/StoreContextProvider";
import HomeIconFill from "../../../assets/image/HomeIconFill.png";
import HomeIcon from "../../../assets/image/homeIcon.png";
import adviceIconFill from "../../../assets/image/adviceIconFill.png";
import adviceIcon from "../../../assets/image/adviceIcon.png";
import timelineIconFill from "../../../assets/image/timelineIconFill.png";
import timelineIcon from "../../../assets/image/timelineIcon.png";
import myPageIcon from "../../../assets/image/myPageIcon.png";
import myPageIconFill from "../../../assets/image/myPageIconFill.png";

function BottomMenu() {
  const { headerStore } = useRootStore();
  const pathname = window.location.pathname;
  const [value, setValue] = React.useState(pathname);

  const changeValue = (newValue: string) => {
    console.log(newValue);
    setValue(newValue);
  };

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 999 }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(e, newValue) => changeValue(newValue)}
      >
        <BottomNavigationAction
          label={
            value === "/" ? (
              <Grid textAlign={"center"}>
                <img src={HomeIconFill} alt="homeIconfill" />
                <Typography
                  style={{
                    color: "#333434",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Main
                </Typography>
              </Grid>
            ) : (
              <Grid textAlign={"center"}>
                <img src={HomeIcon} alt="homeIcon" />
                <Typography
                  style={{
                    color: "#C6C6C6",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Main
                </Typography>
              </Grid>
            )
          }
          value="/"
          href="/"
        />
        <BottomNavigationAction
          label={
            value === "/advice" ? (
              <Grid textAlign={"center"}>
                <img src={adviceIconFill} alt="adviceIconFill" />
                <Typography
                  style={{
                    color: "#333434",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Summary
                </Typography>
              </Grid>
            ) : (
              <Grid textAlign={"center"}>
                <img src={adviceIcon} alt="adviceIcon" />
                <Typography
                  style={{
                    color: "#C6C6C6",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Summary
                </Typography>
              </Grid>
            )
          }
          value="/advice"
          href="/advice"
        />
        <BottomNavigationAction
          label={
            value === "/timeline" ? (
              <Grid textAlign={"center"}>
                <img src={timelineIconFill} alt="timelineIconFill" />
                <Typography
                  style={{
                    color: "#333434",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Timeline
                </Typography>
              </Grid>
            ) : (
              <Grid textAlign={"center"}>
                <img src={timelineIcon} alt="timelineIcon" />
                <Typography
                  style={{
                    color: "#C6C6C6",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  Timeline
                </Typography>
              </Grid>
            )
          }
          value="/timeline"
          href="/timeline"
        />
        <BottomNavigationAction
          label={
            value === "/mypage" ? (
              <Grid textAlign={"center"}>
                <img src={myPageIconFill} alt="myPageIconFill" />
                <Typography
                  style={{
                    color: "#333434",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  MyPage
                </Typography>
              </Grid>
            ) : (
              <Grid textAlign={"center"}>
                <img src={myPageIcon} alt="myPageIcon" />
                <Typography
                  style={{
                    color: "#C6C6C6",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    lineHeight: "11px",
                  }}
                >
                  MyPage
                </Typography>
              </Grid>
            )
          }
          value="/mypage"
          href="/mypage"
        />
      </BottomNavigation>
    </Paper>
  );
}

export default observer(BottomMenu);
